import { useEffect, useState } from 'react';
import { fetchPedidos } from '../../services/pedidoService';
import { IPedido } from '../../interfaces/pedido.interface';

const useFetchPedidos = () => {
  const [pedidos, setPedidos] = useState<IPedido[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const getPedidos = async () => {
      try {
        const data = await fetchPedidos();
        setPedidos(data);
      } catch (err) {
        setError('Falha ao buscar pedidos');
      } finally {
        setLoading(false);
      }
    };

    getPedidos();
  }, [pedidos]);

  return { pedidos, loading, error };
};

export default useFetchPedidos;
